/* eslint-disable import/first */
import React, { useState } from 'react';

import css from './index.module.scss';
import { FormattedMessage } from 'react-intl';
import { AiOutlineDown } from '@react-icons/all-files/ai/AiOutlineDown';
import { AiOutlineUp } from '@react-icons/all-files/ai/AiOutlineUp';

export default function ProductTileDescription({ productDescription = '', descriptionLength = 120 }) {
  const [showMore, setShowMore] = useState(productDescription.length > descriptionLength ? true : false);

  const toggleShowMore = () => {
    setShowMore((prev) => !prev);
  }

  return (
    <>
      <div className={css.description}>
        {productDescription.length <= descriptionLength
          ? productDescription
          : (
            <>
              {`${showMore ? productDescription.substring(0, descriptionLength) : productDescription} `}
              <span className={css.textToggle} onClick={toggleShowMore}>
                <FormattedMessage id={showMore ? 'more' : 'less'} /> {' '} {showMore ? <AiOutlineDown /> : <AiOutlineUp /> }
              </span>
            </>
          )}
      </div>
    </>
  );
}
